import { Grid, Link, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";

const OmniTOS = props => {
  const theme = useTheme();

  return (
    <Grid item>
      <Typography
        variant="subtitle2"
        sx={{
          textAlign: "right",
          margin: theme.spacing(1),
          userSelect: "none",
        }}
      >
        <Link
          href={`${
            window.location.origin.includes("localhost")
              ? `https://dev.omnisciahealth.coach`
              : window.location.origin
          }/assets/legal/TOS.html`}
          to="route"
          target="_blank"
          sx={{ color: theme.palette.primary.main }}
          onClick={() => {
            //   gtag("event", "user_onboarding_TOS", {
            //     invite_key: inviteKey,
            //   });
          }}
        >
          Terms of Service
        </Link>
        {` and `}
        <Link
          href={`${
            window.location.origin.includes("localhost")
              ? `https://dev.omnisciahealth.coach`
              : window.location.origin
          }/assets/legal/privacypolicy.html`}
          to="route"
          target="_blank"
          sx={{ color: theme.palette.primary.main }}
          onClick={() => {
            //   gtag("event", "user_onboarding_privacy_policy", {
            //     invite_key: inviteKey,
            //   });
          }}
        >
          Privacy Policy
        </Link>
      </Typography>
    </Grid>
  );
};

export default OmniTOS;
